/**
 * destinationNotificationDataSlice.js
 * ─────────────────────────────────────────────────────────────────────────────
 * This slice is used exclusively in the Shipping Form.
 * Manages the destination notification toggles (email, SMS, WhatsApp, webhook)
 * that determine how the recipient is notified about their shipment.
 * ─────────────────────────────────────────────────────────────────────────────
 */

import { createSlice } from '@reduxjs/toolkit';

// ─── Initial State ────────────────────────────────────────────────────────────

const initialState = {
  destinationNotificationData: {
    fields: {
      email_destination_notification:   JSON.parse(localStorage.getItem('destinationNotificationsEmailEnabled')) ?? false,
      sms_destination_notification:     JSON.parse(localStorage.getItem('destinationNotificationsSMSEnabled')) ?? false,
      wsp_destination_notification:     JSON.parse(localStorage.getItem('destinationNotificationsWhatsappEnabled')) ?? false,
      webhook_destination_notification: JSON.parse(localStorage.getItem('destinationNotificationsWebhookEnabled')) ?? false,
    },
  },
};

// ─── Slice ────────────────────────────────────────────────────────────────────

const destinationNotificationDataSlice = createSlice({
  name: 'destinationNotificationData',
  initialState,
  reducers: {

    // Notification channel toggles
    setEmailNotification(state, action) {
      const { point, data } = action.payload;
      state.destinationNotificationData.fields[point] = data;
    },
    setSmsNotification(state, action) {
      const { point, data } = action.payload;
      state.destinationNotificationData.fields[point] = data;
    },
    setWspNotification(state, action) {
      const { point, data } = action.payload;
      state.destinationNotificationData.fields[point] = data;
    },
    setWebhookNotification(state, action) {
      const { point, data } = action.payload;
      state.destinationNotificationData.fields[point] = data;
    },

  },
});

// ─── Exports ──────────────────────────────────────────────────────────────────

// Imported in enviar.js
export const {
  setEmailNotification,
  setSmsNotification,
  setWspNotification,
  setWebhookNotification,
} = destinationNotificationDataSlice.actions;

// Used in store.js
const destinationNotificationReducer = destinationNotificationDataSlice.reducer;
export default destinationNotificationReducer;
